module.exports = __webpack_public_path__ + "static/media/story_alive_un.effa73fa.png";